import { useEffect, useMemo, useState } from 'react'
import { IUserPermissions } from '../models/roleAndPermission.model'
import { useSelector } from 'react-redux'
import { getUserProfile } from 'src/app/store/auth'

export interface IUseRolePermission {
  role: string
  userPermissions: IUserPermissions
}

export const useRolePermission = () => {
  const [role, setRole] = useState<string>('')

  const userProfile = useSelector(getUserProfile)

  const userPermissions: IUserPermissions = useMemo(() => {
    let newRes = {}
    if (userProfile?.policies?.length) {
      newRes = userProfile?.policies?.reduce((permission: any, item) => {
        permission[item?.submoduleCodeName] = item?.permissionCodeNames
        return permission
      }, {})
    }
    return newRes
  }, [userProfile])

  useEffect(() => {
    if (userProfile?.role) {
      setRole(userProfile?.role)
    }

    return () => {}
  }, [userProfile])

  return {
    role,
    userPermissions,
  }
}